// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#map {\n  width: 100%;\n  height: 350px;\n}\n", "",{"version":3,"sources":["webpack://src/container/Map/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf","sourcesContent":["#map {\n  width: 100%;\n  height: 350px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
